import { gql } from "@apollo/client";

export const GET_CUSTOM_TIP_MENU = gql`
  query GetCustomTipMenu {
    getCustomTipMenu {
      name
      description
      cost
      friendlyName
      type
      command
      title
      footer
      image
      tipNote
      color
      isActive
      isPrivate
      isSubscribable
      subscriptionWeeklyPrice
      subscriptionMonthlyPrice
      firstWeeklyCharge
      firstMonthlyCharge
      tags
    }
  }
`;

export const GET_CUSTOM_TIP_HISTORY = gql`
  query getCustomTipHistory($userId: String) {
    getCustomTipHistory(userId: $userId) {
      customTips {
        id
        amount
        description
        type
        createdAt
        refundedAt
        refundedBy
      }
      username
    }
  }
`;

export const BROADCASTER_GET_CUSTOM_TIP_HISTORY = gql`
  query getCustomTipHistory($cbUsername: String) {
    getCustomTipHistory(cbUsername: $cbUsername) {
      amount
      description
      type
      createdAt
    }
  }
`;

export const REFUND_CUSTOM_TIP_REDEEM = gql`
  mutation RefundCustomTipRedeem($customTipId: ID!) {
    refundCustomTipRedeem(customTipId: $customTipId) {
      id
      refundedAt
      refundedBy
    }
  }
`;
